module.exports = __webpack_public_path__ + "img/4.457e7491.jpg";